module.exports = __webpack_public_path__ + "img/icon-language-white.b2d5c2e7.svg";